import { generateId } from "@client/lib/random";
import { type Entities, type Entity, EntityType } from "@client/types";
import { values } from "lodash";

export const regenerateIds = (entities: Entities, newRootId?: string): Entities => {
  if (newRootId) {
    var roots = Object.keys(entities).filter((x) => !entities[x].parentId);
    if (roots.length > 1) throw new Error(`Expected one root. Found: ${roots.length}`);

    const rootId = roots[0];
    reCreateIds(entities, (e) => (e.id == rootId ? newRootId : generateId()));
  } else {
    reCreateIds(entities, (e) => (e.type == EntityType.Place ? e.id : generateId()));
  }
  return entities;
};
const reCreateIds = (entities: Entities, getNewId: (e: Entity) => string) => {
  const topIds = values(entities)
    .filter((v) => !v.parentId)
    .map((v) => v.id);

  const oldToNewIds = {};
  iterate(
    topIds,
    entities,
    (e) => {
      const oldId = e.id;
      const newId = getNewId(e);
      e.id = newId;

      entities[newId] = e;

      if (newId != oldId) {
        delete entities[oldId];
      }

      oldToNewIds[oldId] = e.id;

      if (e.childrenIds != null) {
        // we go bottom-top, we can update children now
        e.childrenIds = e.childrenIds.map((childId) => oldToNewIds[childId]);
        for (const childId of e.childrenIds) {
          const child = entities[childId];
          child.parentId = newId;
        }
      }
    },
    false
  );

  return oldToNewIds;
};

const iterate = (topIds: string[], entities: Entities, enter: (e: Entity) => void, topBottom: boolean) => {
  for (const id of topIds) {
    const entity = entities[id];

    if (topBottom) enter(entity);

    if (entity.childrenIds != null) {
      iterate(entity.childrenIds, entities, enter, topBottom);
    }

    if (!topBottom) enter(entity);
  }
};
